<template>
  <div class="file-upload">
    <v-text-field
      v-model="fileName"
      @click="openInputFile"
      :label="label"
      :placeholder="placeholder"
      append-icon="attach_file"
    ></v-text-field>
    <input
      multiple
      type="file"
      style="display: none"
      ref="inputFile"
      accept="image/*"
      @change="onFilePicked"
    />
  </div>
</template>

<script>
export default {
  name: 'FileUploadInput',
  props: {
    label: {
      type: String,
      default: 'File Attachment'
    },
    placeholder: {
      type: String
    }
  },
  data() {
    return {
      fileName: '',
      fileObjects: null,
      fileList: []
    }
  },
  methods: {
    openInputFile() {
      this.$refs.inputFile.click()
    },
    onFilePicked(event) {
      let files = event.target.files
      if (files.length) {
        this.fileName =
          files.length > 1 ? files.length + ' files' : files[0].name
        // // Check validity of file
        // if (this.fileName.lastIndexOf('.') <= 0) {
        //   return
        // }
        // If valid, continue
        // const fr = new FileReader()
        // for (let i = 0; i < files.length; i++) {
        //   fr.readAsDataURL(files[i])
        //   fr.addEventListener('load', () => {
        //     this.url = fr.result
        //     this.fileObjects = files // this is an file that can be sent to server...
        //   })
        // }
        this.fileList = []
        for (let i = 0; i < files.length; i++) {
          this.fileList.push(files[i])
        }
        this.fileObjects = files
      } else {
        this.fileName = ''
        this.fileObjects = null
        this.url = ''
        this.fileList = []
      }
    }
  }
}
</script>

<style lang="scss">
.file-upload {
  .input-file {
    opacity: 0;
    position: absolute;
    margin: -9999px -9999px;
  }
}
</style>
